import { useEffect, useState } from "react";

// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionStatus, InteractionType, InteractionRequiredAuthError, AccountInfo } from "@azure/msal-browser";
import { loginRequestAAD } from "../authConfig";

// Sample app imports
import { ProfileData, GraphData } from "../ui-components/ProfileData";
import { Loading } from "../ui-components/Loading";
import { ErrorComponent } from "../ui-components/ErrorComponent";
import { callMsGraph } from "../utils/MsGraphApiCall";

// Material-ui imports
import Paper from "@mui/material/Paper";
import React from "react";

const ProfileContent = () => {
    const { instance, inProgress } = useMsal();
    const [graphData, setGraphData] = useState<null | GraphData>(null);

    useEffect(() => {
        //Se graphData è nullo e non ci sono interazioni con MSAL in corso 
        if (!graphData && inProgress === InteractionStatus.None) {

            //Effettua la chiamata con GRAPH
            callMsGraph()
            .then(response => {

                setGraphData(response)
            }
            )
            .catch((e) => {
                console.error ("callMsGraph Catch: " + e);
                //Se richiesta Autorizzazione Effettua acqusizione Token Redirect
                if (e instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect({
                        ...loginRequestAAD,
                        account: instance.getActiveAccount() as AccountInfo
                    });
                }
            });
        }
    }, [inProgress, graphData, instance]);

    return (
        <Paper>
            {graphData ? <ProfileData graphData={graphData} /> : "no graphData available"}
        </Paper>
    );
};

export function Profile() {
    const authRequest = {
        //...loginRequestAAD
        ...{scopes: ["api://5d30dc67-db8d-4111-954a-697cf0d10eb7/DEV-AAD"]}
    };

    return (
        <>
            <h4> Profile Component</h4>

            
                <MsalAuthenticationTemplate
                    interactionType={InteractionType.Redirect}
                    authenticationRequest={authRequest}
                    errorComponent={ErrorComponent}
                    loadingComponent={Loading}
                >
                    
            
                  <ProfileContent />  
                </MsalAuthenticationTemplate>
            
        </>
    )
};